const EDIT_QNA_DRAFT_PREFIX = 'admin:qnaDraft:edit:'

const getSessionStorage = () => {
    if (typeof window === 'undefined') {
        return null
    }

    return window.sessionStorage
}

const normalizeReplyValue = (value) => {
    if (value === undefined || value === null) {
        return ''
    }

    return String(value)
}

// Q/A 문의 상세는 운영자가 다시 작성해야 하는 답변 값만 sessionStorage에 남긴다.
export const createQnaDraftPayload = ({ data = {} } = {}) => {
    return {
        data: {
            reply: normalizeReplyValue(data.reply),
        }
    }
}

// 서버 기본값 위에 draft만 덮어써서 새로고침 뒤에도 답변 작성 흐름을 이어간다.
export const applyQnaDraft = ({ baseData = {}, draft }) => {
    if (!draft) {
        return {
            data: {
                ...baseData,
                reply: normalizeReplyValue(baseData.reply),
            },
        }
    }

    const draftData = draft.data || {}

    return {
        data: {
            ...baseData,
            reply: draftData.reply === undefined
                ? normalizeReplyValue(baseData.reply)
                : normalizeReplyValue(draftData.reply),
        }
    }
}

export const createEditQnaDraftKey = (qnaId) => `${EDIT_QNA_DRAFT_PREFIX}${qnaId}`

export const readQnaDraft = (draftKey) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return null
    }

    try {
        const storedValue = storage.getItem(draftKey)
        return storedValue ? JSON.parse(storedValue) : null
    } catch (_error) {
        return null
    }
}

export const saveQnaDraft = (draftKey, draftValue) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return
    }

    try {
        storage.setItem(draftKey, JSON.stringify(draftValue))
    } catch (_error) {
        // sessionStorage가 막혀 있어도 답변 작성 흐름은 그대로 유지한다.
    }
}

export const clearQnaDraft = (draftKey) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return
    }

    try {
        storage.removeItem(draftKey)
    } catch (_error) {
        // storage 정리에 실패해도 화면 동작은 계속 진행한다.
    }
}
